// eslint-disable-next-line
import React from "react";

function About() {
  return (
    <div>
      <div className="about-division-1">
        <div className="about-desc">
          <p className="heading-journey">About Me</p>
          <div className="about-content">Hello! My name is Srishti Maurya.</div>
          <div className="about-content">
            <i>
              <b>
                Mobile Development Powerhouse | React Native | Cross-Platform
                Apps
              </b>
            </i>
          </div>
          <div className="about-content">
            Mobile developer with 2+ years of experience crafting
            high-performance apps for iOS and Android. My expertise lies in
            leveraging React Native, ReactJS, and Redux/Redux Toolkit to build
            intuitive and engaging user interfaces, while ensuring smooth
            native-like performance.
          </div>
          <div className="about-content">
            <i>
              <b>Key Highlights:</b>
            </i>
          </div>
          <div className="about-content">
            <li>
              Successfully transitioned existing React web apps to React Native,
              streamlining the development process and expanding reach.
            </li>
            <li>
              Experienced in bug fixing and performance optimization techniques,
              delivering apps that feel responsive and delight users.
            </li>
            <li>
              Architected scalable React Native apps with reusable UI
              components, data stores, and actions for seamless real-time data
              handling.
            </li>
            <li>
              Published apps on both Apple App Store and Google Play Store, with
              hands-on experience navigating submission processes.
            </li>
            <li>
              Extensive testing knowledge, ensuring flawless app quality through
              TestFlight and other testing frameworks.
            </li>
          </div>
          <div className="about-content">
            <i>
              <b>Skills Snapshot: </b>
            </i>
          </div>

          <div className="about-content">
            <li>
              Programming Languages: HTML, CSS, JavaScript (ES6+), TypeScript
            </li>
            <li>Libraries/Frameworks: React Native, ReactJS, Redux</li>
            <li>
              Development & Deployment Tools: Xcode, Gradle, TestFlight, Play
              Store Console, App Store, Firebase
            </li>
            <div>
              <div className="tech-wrapper">
                <div className="tech-container">
                  <div>
                    <img
                      src="./images/arrow.png"
                      className="arrow-pointer"
                      alt="about-img"
                    />
                    JavaScript
                  </div>
                  <div>
                    <img
                      src="./images/arrow.png"
                      className="arrow-pointer"
                      alt="about-img"
                    />
                    TypeScript
                  </div>
                  <div>
                    <img
                      src="./images/arrow.png"
                      className="arrow-pointer"
                      alt="about-img"
                    />
                    ReactJS
                  </div>
                </div>
                <div className="tech-container">
                  <div>
                    <img
                      src="./images/arrow.png"
                      className="arrow-pointer"
                      alt="about-img"
                    />
                    ReactNative
                  </div>
                  <div>
                    <img
                      src="./images/arrow.png"
                      className="arrow-pointer"
                      alt="about-img"
                    />
                    Redux
                  </div>
                  <div>
                    <img
                      src="./images/arrow.png"
                      className="arrow-pointer"
                      alt="about-img"
                    />
                    Rest API
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="img-container-xl">
          <img src="./images/user3.png" className="coding" alt="about-img" />
        </div>
      </div>
    </div>
  );
}

export default About;
